const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Games",
  },
  {
    path: ["/wip", "/work-in-progress"],
    exact: true,
    component: "WorkInProgress",
  },
  {
    path: ["/archive"],
    exact: true,
    component: "Archive",
  },
  {
    path: ["/minigames"],
    exact: true,
    component: "MiniGames",
  },
  {
    path: ["/magicbricks"],
    exact: true,
    component: "Archive",
  },
  {
    path: ["/tractorcard"],
    exact: true,
    component: "Archive",
  },
];

export default routes;
